/** Let keyboard events reach inputs inside database UI; block other keys from the editor. */
export function stopBubbleUnlessFormField(event: {
  stopPropagation: () => void;
  target?: EventTarget | null;
}): void {
  const el = event.target as HTMLElement | null;
  if (el?.closest('input, textarea, select')) {
    return;
  }
  event.stopPropagation();
}
